import { useRef } from "react";

import LightBlubIcon from "../../icons/lightBlub.icon";
import XMarkIcon from "../../icons/xMark.icon";

interface InfoBannerProps {
  message: string;
}

export default function InfoBanner({ message }: InfoBannerProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const handleOpen = () => {
    dialogRef.current?.showModal();
  };

  const handleClose = () => {
    dialogRef.current?.close();
  };

  return (
    <>
      <button type="button" onClick={handleOpen}>
        <LightBlubIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
      </button>
      <dialog ref={dialogRef} className="max-w-[800px] p-6 dark:bg-her-lightgray2 dark:text-her-lightgray">
        <div className="">
          <LightBlubIcon className="w-7 h-7 text-blue-600 dark:text-blue-300" />
          <div className="mt-6">{message}</div>
        </div>
        <button type="button" onClick={handleClose} className="absolute top-6 right-6" aria-label="Dismiss">
          <XMarkIcon className="w-5 h-5" />
        </button>
      </dialog>
    </>
  );
}
